import React from "react";
import "./LogoutButton.css";
import { Strings } from "../../../utils/strings";

type props = {
  onPress: () => void;
};

export const LogoutButton: React.FC<props> = ({ onPress }) => {
  return (
    <div onClick={onPress} className="logout-btn-container">
      <span className="logout-btn-text">{Strings.LOGOUT}</span>
    </div>
  );
};
